import { render } from "./ContainerComponent.vue?vue&type=template&id=771b037a&scoped=true"
import script from "./ContainerComponent.vue?vue&type=script&lang=js"
export * from "./ContainerComponent.vue?vue&type=script&lang=js"

import "./ContainerComponent.vue?vue&type=style&index=0&id=771b037a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771b037a"]])

export default __exports__